import { CheckCircleIcon } from '@heroicons/react/20/solid';
import PropTypes from 'prop-types';

function ConvertOrderSuccess({ onClose }) {
  return (
    <div className="space-y-6">
      <div className="flex flex-col items-center rounded-xl border border-green-200 bg-green-50 p-8">
        <CheckCircleIcon className="h-12 w-12 text-green-500" />
        <h3 className="mt-4 font-semibold text-gray-900 text-lg">
          Order Converted Successfully
        </h3>
        <p className="mt-2 text-center text-gray-600 text-sm">
          This order has been converted to a courtesy order. All financial
          values have been zeroed out and the order flags have been updated.
        </p>
      </div>

      <div className="flex justify-end">
        <button
          type="button"
          onClick={onClose}
          className="inline-flex items-center rounded-lg border border-transparent bg-blue-600 px-6 py-2 font-medium text-sm text-white shadow-sm transition-colors hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
        >
          Close
        </button>
      </div>
    </div>
  );
}

ConvertOrderSuccess.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default ConvertOrderSuccess;
